export default __webpack_public_path__ + "static/media/three_card.0b30d52b.png";